import { render, staticRenderFns } from "./mediakit.vue?vue&type=template&id=5d3f1a53&scoped=true&"
import script from "./mediakit.vue?vue&type=script&lang=js&"
export * from "./mediakit.vue?vue&type=script&lang=js&"
import style0 from "./mediakit.vue?vue&type=style&index=0&id=5d3f1a53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f1a53",
  null
  
)

export default component.exports